export enum AccountStatus {
    created = 'created',
    registered = 'registered',
    clubclient = 'clubclient',
    blocked = 'blocked'
}